import React from "react";
import { Grid } from "@mui/material";
import Button from "@mui/material/Button";

const MobileSectionsButton: React.FC<{isMobile: boolean, toggle: () => void}> =
({ isMobile, toggle }) => {
  if (isMobile) {
    return (
      <Grid size={{ xs: 12 }}>
        <Button size="small" onClick={toggle}>← Sections</Button>
      </Grid>
    );
  }
  return null;
};

export default MobileSectionsButton;
